// Branded, colored spreadsheet export. Builds a styled HTML table and saves it
// as an .xls file — Excel/Sheets render the colors, so reports match the app's UI.
// Accent follows the active brand (Augment magenta / DIH petrol).
function brandAccent() {
  try {
    if (JSON.parse(localStorage.getItem("augment-hr.settings"))?.brand === "dih")
      return { main: "#005677", dark: "#004864", light: "#E2EEF2" };
  } catch { /* default below */ }
  return { main: "#DC0069", dark: "#9A0048", light: "#FCE8F0" };
}
const _accent = brandAccent();
const BRAND = _accent.main;
const BRAND_DARK = _accent.dark;
const BRAND_LIGHT = _accent.light;
const TEXT = "#111927";
const MUTED = "#6C737F";
const BORDER = "#E5E7EB";

const esc = (v) =>
  String(v ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

export function downloadStyledXls(filename, title, headers, rows, totalsRow) {
  const cols = headers.length;

  const headRow =
    "<tr>" +
    headers
      .map(
        (h) =>
          `<th style="background:${BRAND};color:#ffffff;font-weight:600;padding:9px 14px;border:1px solid ${BRAND_DARK};text-align:left;white-space:nowrap;">${esc(h)}</th>`
      )
      .join("") +
    "</tr>";

  const bodyRows = rows
    .map(
      (r, i) =>
        `<tr style="background:${i % 2 ? BRAND_LIGHT : "#ffffff"};">` +
        r
          .map(
            (c) =>
              `<td style="padding:7px 14px;border:1px solid ${BORDER};color:${TEXT};">${esc(c)}</td>`
          )
          .join("") +
        "</tr>"
    )
    .join("");

  const totals = totalsRow
    ? "<tr>" +
      totalsRow
        .map(
          (c) =>
            `<td style="padding:9px 14px;border:1px solid ${BRAND};background:${BRAND_LIGHT};color:${BRAND_DARK};font-weight:700;">${esc(c)}</td>`
        )
        .join("") +
      "</tr>"
    : "";

  const html =
    `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel">` +
    `<head><meta charset="utf-8"></head><body>` +
    `<table style="border-collapse:collapse;font-family:Inter,Arial,sans-serif;font-size:13px;">` +
    `<tr><td colspan="${cols}" style="background:${BRAND_DARK};color:#ffffff;font-size:18px;font-weight:700;padding:14px;">Augment HR &nbsp;·&nbsp; ${esc(title)}</td></tr>` +
    `<tr><td colspan="${cols}" style="color:${MUTED};padding:4px 14px 10px;font-size:11px;">Generated ${esc(new Date().toLocaleString())} &nbsp;·&nbsp; ${rows.length} records</td></tr>` +
    headRow +
    bodyRows +
    totals +
    `</table></body></html>`;

  const url = URL.createObjectURL(new Blob(["﻿" + html], { type: "application/vnd.ms-excel" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.replace(/\.(csv|xls)$/i, "") + ".xls";
  a.click();
  URL.revokeObjectURL(url);
}
